import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Heart, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import ProductCard from '@/components/ProductCard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Favorites = () => {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchFavorites = async () => {
    try {
      const response = await axios.get(`${API}/favorites`);
      setFavorites(response.data);
    } catch (error) {
      console.error('Error fetching favorites:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFavorites();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen pt-24">
        <div className="container-luxury py-12">
          <h1 className="font-serif text-4xl mb-12">Meus Favoritos</h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {[...Array(4)].map((_, idx) => (
              <div key={idx} className="space-y-4">
                <div className="aspect-[3/4] skeleton" />
                <div className="h-4 w-3/4 skeleton" />
                <div className="h-4 w-1/4 skeleton" />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-24" data-testid="favorites-page">
      <div className="container-luxury py-12">
        <h1 className="font-serif text-4xl mb-12">Meus Favoritos</h1>

        {favorites.length === 0 ? (
          <div className="empty-state">
            <Heart className="w-16 h-16 text-muted-foreground mb-6" />
            <h2 className="font-serif text-2xl mb-4">Nenhum favorito ainda</h2>
            <p className="text-muted-foreground mb-8">
              Explore nossa coleção e salve suas peças favoritas
            </p>
            <Link to="/shop">
              <Button className="btn-primary" data-testid="explore-btn">
                Explorar Coleção
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {favorites.map((product) => (
              <ProductCard 
                key={product.id} 
                product={product} 
                onFavoriteChange={fetchFavorites}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Favorites;
